import TreeTable from './Table/Table';

TreeTable.install = (Vue) => {
  Vue.component(TreeTable.name, TreeTable);
};

export default TreeTable;



// WEBPACK FOOTER //
// ./src/index.js